<template>
    <div class="book-home">
      <article class="about  active" data-page="about">
      <header>
          <h2 class="h2 article-title">Book Details</h2>
      </header>
      <BookHeader 
        :title="book.title" 
        :bookCover="book.coverImage" 
        :authorName="book.author.name"
        :tags="book.tags" 
        :id="book.id"
        style="border-style: solid;background: var(--border-gradient-onyx);border-radius: 5px;"
      />

      <div v-html="book.audioLink" style="margin: 15px;">

      </div>

      <section class="book-summary">
          <h2 style="color: #ffffffe5;"><i class="el-icon-s-promotion" style="color: #ffbf5e;"></i>  Pitch</h2>
          
          <p class="takeaway-item" 
          v-html="book.summary"></p>
        </section>

      <AuthorInfo 
        :authorName="book.author.name" 
        :authorImage="book.author.image" 
        :authorDescription="book.author.description" 
      />

      <section class="book-content">
        

        <section class="key-takeaways">
          <h2 style="color: #ffffffe5;"><i class="el-icon-s-promotion" style="color: #ffbf5e;"></i>  Key Takeaways</h2>
          <div 
            v-for="(takeaway, index) in book.keyTakeaways" 
            :key="index" 
            class="takeaway-item"
          >
            <h3 class="takeaway-title">{{ index+1 }}- {{ takeaway.title }}</h3>
            <p 
              class="takeaway-content" 
              v-html="takeaway.content"
            ></p>
          </div>
        </section>
  
      </section>
    </article>
    </div>
  </template>
  
  <script>
  import BookHeader from '@/components/BookHeader.vue';
  import AuthorInfo from '@/components/AuthorInfo.vue';
  import books from '@/data/books';
  
  export default {
    name: 'BookDetailPage',
    components: {
      BookHeader,
      AuthorInfo
    },
    data() {
      return {
        book: null
      };
    },
    created() {
      const bookId = this.$route.params.id; // Assumes Vue Router is set up
      this.book = books.find(book => book.id === parseInt(bookId));
    }
  };
  </script>
  
  <style scoped>
  .book-detail-page {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .book-content {
    margin-top: 20px;
  }
  
  .book-content h2 {
    margin-top: 20px;
    color: #333;
  }
  
  .book-content p {
    line-height: 1.6;
  }

  .key-takeaways {
  margin-bottom: 20px;
}

.takeaway-item {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.takeaway-title {
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.takeaway-content {
  line-height: 1.6;
}

/* Additional styling for inline elements */
.takeaway-content strong {
  font-weight: bold;
}

.takeaway-content em {
  font-style: italic;
}
  </style>
  